/* Memoria: price summary above Add to cart for jewelry without the chain picker (rings, earrings, bracelets...).
   As soon as a paid option of the options app (Globo) is chosen, a small overview appears:
   "Ring 14 karaat € 869 / Gravure +€ 40 / Bladgoud +€ 25 / Totaal € 934" (Memoria: Toevoeging = Glitterpoeder/Bladgoud). The Add to cart button always shows the
   total ("In winkelwagen · € 869"). NL: karaat = variantoptie of Globo-optie "Gehalte" ("14 Karaat"), bedragen in nl-NL-notatie
   (DE/FR/US-herkenning blijft als reserve). Globo's own "Selections will add ..." line is hidden while the overview shows.
   The displayed product price already includes Globo's extras; the ring itself = displayed price minus extras. */
(function () {
  if (window.mjPriceSummary) return;
  window.mjPriceSummary = true;

  // Taal: NL standaard; op /en/ Engels. Andere talen vallen terug op NL.
  var EN = /^en/i.test(document.documentElement.lang || '');
  var T = EN
    ? { engraving: 'Engraving', glitter: 'Glitter', flakes: 'Gold leaf', wrist: 'Wrist size', special: 'Custom size', ring: 'Ring size', option: 'Option', item: 'Jewellery', total: 'Total' }
    : { engraving: 'Gravure', glitter: 'Glitter', flakes: 'Bladgoud', wrist: 'Polsmaat', special: 'Speciale maat', ring: 'Ringmaat', option: 'Optie', item: 'Sieraad', total: 'Totaal' };

  // Works for "1.234,56 €", "489,00 €", "€489", "$1,234.56": the last separator followed by 1-2 digits is the decimal mark
  function cents(text) {
    var t = String(text || '').replace(/[^0-9.,]/g, '');
    if (!t) return null;
    var m = t.match(/^(.*)[.,](\d{1,2})$/);
    var n = m ? parseFloat(m[1].replace(/[.,]/g, '') + '.' + m[2]) : parseFloat(t.replace(/[.,]/g, ''));
    return isNaN(n) ? null : Math.round(n * 100);
  }
  function money(c, cur, locale) {
    var opts = { style: 'currency', currency: cur || 'EUR' };
    if (EN) locale = 'en-IE';
    if (c % 100 === 0) { opts.minimumFractionDigits = 0; opts.maximumFractionDigits = 0; }
    try { return new Intl.NumberFormat(locale || 'nl-NL', opts).format(c / 100); } catch (e) {
      try { return new Intl.NumberFormat('nl-NL', opts).format(c / 100); } catch (e2) { return '€ ' + (c / 100).toFixed(2).replace('.', ','); }
    }
  }
  // Chosen paid Globo options (same rules as the chain picker); karat stays part of the product price
  function extras(form) {
    var out = [];
    // "(+15,00 €)", "(+ €15)", "(+$15.00)"
    var priceOf = function (t) { var m = String(t || '').match(/\(\s*\+\s*[^\d(]*([\d.,]+)[^\d()]*\)/); return m ? cents(m[1]) : 0; };
    var clean = function (t) { return String(t || '').replace(/\s+/g, ' ').replace(/\(.*$/, '').trim(); };
    form.querySelectorAll('.gpo-element').forEach(function (el) {
      if (!el.offsetParent) return;
      var labEl = el.querySelector('.gpo-label');
      var lab = labEl ? labEl.textContent.replace(/\s+/g, ' ').trim() : '';
      if (/kara+t|carat|teneur|gehalt|gold\s*content/i.test(lab)) return;
      var nameOf = function (opt) {
        if (/grav|engrav/i.test(lab)) return T.engraving;
        if (/glitter|glitzer|paillette|shimmer/i.test(lab)) return T.glitter;
        if (/blad\s*goud|blattgold|feuilles?\s*d.?\s*or|gold flake/i.test(lab)) return T.flakes;
        if (/pols\s*maat|armband\s*maat|wrist\s*size|bracelet\s*size/i.test(lab)) return T.wrist;
        if (/speciale\s*maat|special\s*size|custom\s*size/i.test(lab)) return T.special;
        if (/ringmaat|(^|\s)maat(\s|$|:|\*|\?)|^\s*size\s*(\*|:|\(|$)|sondergr|(^|\s)ma(ß|ss)(\s|$|:|\*)|ringgr|gr(ö|oe)(ß|ss)e|ring\s*size/i.test(lab)) return opt && /speciaal|op\s*maat|nach ma(ß|ss)|speziell|sonder|custom|special/i.test(opt) ? T.special : (opt || T.ring);
        if (/insluitsel|einschluss|inclusion/i.test(lab) && opt) return opt;
        // Memoria: "Toevoeging" (radio: Glitterpoeder / Bladgoud) -> name of the chosen option
        if (/toevoeging|addition|finish/i.test(lab) && opt) return opt;
        return clean(lab).replace(/^add\s+(an?\s+)?/i, '').replace(/\s*(toevoegen|hinzuf(ü|ue)gen)\s*\??$/i, '').replace(/\?$/, '').trim() || opt || T.option;
      };
      el.querySelectorAll('select').forEach(function (s) {
        var o = s.options[s.selectedIndex];
        if (!o || !o.value) return;
        var c = priceOf(o.text);
        if (c) out.push({ name: nameOf(clean(o.text)), cents: c });
      });
      el.querySelectorAll('input[type="checkbox"]:checked, input[type="radio"]:checked').forEach(function (i) {
        var l = i.closest('label');
        var c = priceOf(l && l.textContent) || priceOf(lab);
        if (c) out.push({ name: nameOf(clean(l && l.textContent)), cents: c });
      });
    });
    return out;
  }

  function init() {
    var host = document.querySelector('[data-mj-ps]');
    var form = document.querySelector('product-form');
    if (!host || !form || document.querySelector('mj-gold-chain')) return;
    var info = form.closest('.product__info-container') || document.body;
    var priceEl = info.querySelector('[id^="price-"]');
    var cur = host.dataset.currency, locale = host.dataset.locale, label = host.dataset.label || T.item;
    var box = document.createElement('div');
    box.className = 'mj-ps';
    box.hidden = true;
    var last = '';

    function visibleBtn() {
      var btns = Array.prototype.slice.call(form.querySelectorAll('.product-form__submit'));
      return btns.filter(function (b) { return b.offsetParent !== null; })[0] || btns[0];
    }
    function shownPrice() {
      if (!priceEl) return null;
      var cands = Array.prototype.slice.call(priceEl.querySelectorAll('.price__sale .price-item--sale, .price__regular .price-item--regular'));
      var el = cands.filter(function (e) { return e.offsetParent !== null; })[0] || cands[0];
      return el ? cents(el.textContent) : null;
    }
    function render() {
      var btn = visibleBtn();
      if (btn && btn.previousElementSibling !== box) btn.parentNode.insertBefore(box, btn);
      var p = shownPrice();
      if (p === null) return;
      var ex = extras(form);
      var exSum = ex.reduce(function (a, x) { return a + x.cents; }, 0);
      var on = ex.length > 0 && exSum < p;
      // NL: karat is the variant option "Gehalte" ("14 Karaat") or the Globo option "Gehalte"; fallbacks: DE "Karat", US "Gold Karat"
      var kEl = info.querySelector('input[name="Gehalte"]:checked') || info.querySelector('select[name="Gehalte"]') ||
        info.querySelector('select[name="options[Gehalte]"]') ||
        info.querySelector('input[name="Karat"]:checked') || info.querySelector('select[name="Karat"]') ||
        info.querySelector('select[name="options[Karat]"]') ||
        info.querySelector('input[name="Gold Karat"]:checked') || info.querySelector('select[name="Gold Karat"]') ||
        // EN (/en/): vertaalde optienaam "Karat" (boven), "Carat" of "Gold content"
        info.querySelector('input[name="Carat"]:checked') || info.querySelector('select[name="Carat"]') ||
        info.querySelector('input[name="Gold content"]:checked') || info.querySelector('select[name="Gold content"]') ||
        info.querySelector('select[name="options[Carat]"]') || info.querySelector('select[name="options[Gold content]"]') ||
        info.querySelector('.gpo-element input[name*="gehalt" i]:checked') || info.querySelector('.gpo-element select[name*="gehalt" i]') ||
        info.querySelector('.gpo-element input[name*="karat" i]:checked') || info.querySelector('.gpo-element select[name*="karat" i]') ||
        info.querySelector('.gpo-element input[name*="gold content" i]:checked') || info.querySelector('.gpo-element select[name*="gold content" i]');
      var km = kEl && String(kEl.value).match(/(9|14|18)\s*(Kara+t|Carats?|kt|K)\b/i);
      var name = km ? (EN ? km[1] + 'K ' + label : label + ' ' + km[1] + ' karaat') : label;
      var html = on
        ? '<div><span>' + name + '</span><span>' + money(p - exSum, cur, locale) + '</span></div>' +
          ex.map(function (x) { return '<div><span>' + x.name + '</span><span>+' + money(x.cents, cur, locale) + '</span></div>'; }).join('') +
          '<div class="is-total"><span>' + T.total + '</span><span>' + money(p, cur, locale) + '</span></div>'
        : '';
      if (html !== last) { last = html; box.innerHTML = html; }
      if (box.hidden === on) box.hidden = !on;
      info.classList.toggle('mj-ps-on', on);
      // Button always shows the total
      form.querySelectorAll('.product-form__submit').forEach(function (b) {
        var t = b.querySelector('.mj-ps-btn-total');
        if (!t) {
          t = document.createElement('span');
          t.className = 'mj-ps-btn-total';
          var first = b.querySelector('span');
          if (first) first.after(t); else b.appendChild(t);
        }
        var txt = '· ' + money(p, cur, locale);
        if (t.textContent !== txt) t.textContent = txt;
      });
    }
    var queued;
    function schedule() { clearTimeout(queued); queued = setTimeout(render, 60); }
    document.addEventListener('change', schedule); // Globo options and the theme's variant picker (karat)
    form.addEventListener('click', schedule);
    if (window.MutationObserver) {
      if (priceEl) new MutationObserver(schedule).observe(priceEl, { childList: true, subtree: true, characterData: true });
      var wrap = form.querySelector('.product-form__buttons');
      if (wrap) new MutationObserver(function (list) {
        // ignore our own updates
        if (list.every(function (m) { return box.contains(m.target) || (m.target.classList && m.target.classList.contains('mj-ps-btn-total')); })) return;
        schedule();
      }).observe(wrap, { childList: true, subtree: true });
    }
    render();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
